// extracted by mini-css-extract-plugin
module.exports = {"menu":"widget-recents--menu--2VhhJ","info":"widget-recents--info--XYmxQ","signout":"widget-recents--signout--2vSn2"};